// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"); */

.modalOverlay_kL5AU {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--_00000020-background);

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  transition: opacity 300ms ease-in-out;
  border-radius: 10px;
}

.modalContent_GYI6V {
  display: flex;
  flex-direction: column;
  background-color: var(--f5-background);
  border-radius: 8px;
  /* box-shadow: 0 2px 10px var(--_0000001a-shadow); */
  width: 100%;
  max-width: 500px;
  gap: 6px;
  transform: scale(1);
  animation: scaleUp_rnE4H_J7kbu 300ms ease-out forwards;
  /* font-family: "Inter", sans-serif; */
  overflow: hidden;
}

.scaleDown_plSPH {
  animation: scaleDown_plSPH 300ms ease-in forwards;
}

@keyframes scaleUp_rnE4H {
  from {
    transform: scale(0);
  }

  to {
    transform: scale(1);
  }
}

@keyframes scaleDown_plSPH {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(0);
  }
}

.fadeOut_xTXP2 {
  opacity: 0;
}


.headerLeft_C8JkB {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--_2-color);
  font-size: 14px;
  font-weight: 600;
  gap: 10px;
}

.closeIcon_F2egE {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  cursor: pointer;
  border-radius: 4px;
  background: var(--f6-background);
  -webkit-user-select: none;
          user-select: none;
}

.footerContainer_rhkwj {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  height: 64px;
  gap: 16px;
}

.newFolderButton_StOBX {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #232222;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #cbcbcb;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.selectButton_haII0 {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white-background);
  padding: 8px 16px;
  border-radius: 8px;
  background: var(--_10a37f-background);
  border: 1px solid var(--_10a37f-background);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.contentContainer_Pfkaf {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  max-height: 55vh;
  overflow-y: auto;
}

.contentContainer_Pfkaf::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.contentContainer_Pfkaf::-webkit-scrollbar-thumb {
  background-color: var(--e2-background);
  border-radius: 12px;
}

.contentContainer_Pfkaf::-webkit-scrollbar-track {
  background: transparent;
}

.messageText_XJ47v {
  font-size: 16px;
  color: var(--_2-color);
  font-weight: 500;
}

.titleMessage_eFtem {
  font-size: 20px;
  color: var(--_2-color);
  font-weight: 600;
  text-align: center;
  margin: 24px 0px 0px;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/ConfirmationPopup/ConfirmationPopup.module.css"],"names":[],"mappings":"AAAA,qGAAqG;;AAErG;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6CAA6C;;EAE7C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,oDAAoD;EACpD,WAAW;EACX,gBAAgB;EAChB,QAAQ;EACR,mBAAmB;EACnB,sDAAgD;EAChD,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,iDAA2C;AAC7C;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB","sourcesContent":["/* @import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\"); */\n\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: var(--_00000020-background);\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999999;\n  transition: opacity 300ms ease-in-out;\n  border-radius: 10px;\n}\n\n.modalContent {\n  display: flex;\n  flex-direction: column;\n  background-color: var(--f5-background);\n  border-radius: 8px;\n  /* box-shadow: 0 2px 10px var(--_0000001a-shadow); */\n  width: 100%;\n  max-width: 500px;\n  gap: 6px;\n  transform: scale(1);\n  animation: scaleUp_rnE4H 300ms ease-out forwards;\n  /* font-family: \"Inter\", sans-serif; */\n  overflow: hidden;\n}\n\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n}\n\n@keyframes scaleUp {\n  from {\n    transform: scale(0);\n  }\n\n  to {\n    transform: scale(1);\n  }\n}\n\n@keyframes scaleDown {\n  from {\n    transform: scale(1);\n  }\n\n  to {\n    transform: scale(0);\n  }\n}\n\n.fadeOut {\n  opacity: 0;\n}\n\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  color: var(--_2-color);\n  font-size: 14px;\n  font-weight: 600;\n  gap: 10px;\n}\n\n.closeIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 31px;\n  height: 31px;\n  cursor: pointer;\n  border-radius: 4px;\n  background: var(--f6-background);\n  user-select: none;\n}\n\n.footerContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  height: 64px;\n  gap: 16px;\n}\n\n.newFolderButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #232222;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: 1px solid #cbcbcb;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  user-select: none;\n}\n\n.selectButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white-background);\n  padding: 8px 16px;\n  border-radius: 8px;\n  background: var(--_10a37f-background);\n  border: 1px solid var(--_10a37f-background);\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  user-select: none;\n}\n\n.contentContainer {\n  display: flex;\n  flex-direction: column;\n  padding: 0 20px;\n  max-height: 55vh;\n  overflow-y: auto;\n}\n\n.contentContainer::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.contentContainer::-webkit-scrollbar-thumb {\n  background-color: var(--e2-background);\n  border-radius: 12px;\n}\n\n.contentContainer::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.messageText {\n  font-size: 16px;\n  color: var(--_2-color);\n  font-weight: 500;\n}\n\n.titleMessage {\n  font-size: 20px;\n  color: var(--_2-color);\n  font-weight: 600;\n  text-align: center;\n  margin: 24px 0px 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `modalOverlay_kL5AU`,
	"modalContent": `modalContent_GYI6V`,
	"scaleUp_rnE4H": `scaleUp_rnE4H_J7kbu`,
	"scaleDown": `scaleDown_plSPH`,
	"fadeOut": `fadeOut_xTXP2`,
	"headerLeft": `headerLeft_C8JkB`,
	"closeIcon": `closeIcon_F2egE`,
	"footerContainer": `footerContainer_rhkwj`,
	"newFolderButton": `newFolderButton_StOBX`,
	"selectButton": `selectButton_haII0`,
	"contentContainer": `contentContainer_Pfkaf`,
	"messageText": `messageText_XJ47v`,
	"titleMessage": `titleMessage_eFtem`,
	"scaleUp": `scaleUp_rnE4H`
};
export default ___CSS_LOADER_EXPORT___;
